import React from 'react';
import { fx } from '../../fx.js';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

/**
 * Search input with the ⌕ glyph and the one cut corner.
 *
 * @param {object} p
 * @param {string} [p.value]
 * @param {(v: string) => void} [p.onChange]
 * @param {string} [p.placeholder]
 * @param {number|string} [p.width]
 * @param {boolean} [p.grow]
 * @param {React.CSSProperties} [p.style]
 * @param {boolean} [p.autoFocus]
 */
export function SearchBox({ value, onChange, placeholder, width, grow, style, autoFocus }) {
  return h('label', {
    style: { display: 'inline-flex', alignItems: 'center', gap: 8, padding: '7px 12px', background: 'var(--input)', border: ink(2), borderRadius: '10px 10px 10px var(--r-cut)', boxShadow: 'var(--el-1)', width, flex: grow ? '1 1 220px' : undefined, boxSizing: 'border-box', ...style }
  },
    h('span', { 'aria-hidden': true, className: 'gx-glyph', style: { display: 'inline-block', fontFamily: BODY, fontWeight: 800, fontSize: 13, color: 'var(--mut)' } }, '⌕'),
    h('input', { value, autoFocus, onFocus: (e) => { const g = e.target.previousSibling; fx.boop && fx.boop(g, 1.6); }, onChange: (e) => onChange && onChange(e.target.value), placeholder, style: { flex: 1, minWidth: 0, border: 'none', outline: 'none', background: 'transparent', fontFamily: BODY, fontSize: 13.5, fontWeight: 600, color: 'var(--tx)' } })
  );
}
